module.exports = __webpack_public_path__ + "media/images/user_icon_2-0608db51.png";